import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
};

const FORM_INITIAL_STATE = {
  'values': {
    'code': '',
    'description': '',
    'value': '',
  },
};

const updateList = (list, newValue) => {
  const position = list.findIndex((element) => element.code === newValue.code);
  const newList = [...list];
  if (position === -1) {
    newList.push(newValue);
    return newList;
  }
  newList[position] = newValue;
  return newList;
};

export const parameters = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_SYSTEM_PARAMETER]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_SYSTEM_PARAMETER]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [...updateList(state.list, action.response.data)],
    }),
    [ActionTypes.FETCHED_SYSTEM_PARAMETER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.FETCHING_SYSTEM_PARAMETERS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_SYSTEM_PARAMETERS]: (state, action) => ({
      ...state,
      'list': action.response.data,
      'loading': false,
    }),
    [ActionTypes.FETCHED_SYSTEM_PARAMETERS_FAILED]: (state, action) => ({
      ...state,
      'list': [],
      'loading': false,
    }),
    [ActionTypes.DELETE_SYSTEM_PARAMETERS_DATA]: () => ({
      ...state,
      'list': [],
      'loading': false,
    }),
  })(state, action);
};


export const parametersForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.FETCHED_SYSTEM_PARAMETER]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        'code': action.response.data.code,
        'description': action.response.data.description,
        'value': action.response.data.value,
      },
    }),
    [ActionTypes.FETCHED_SYSTEM_PARAMETER_FAILED]: (state) => ({
      ...state,
      'values': {
        ...state.values,
        'code': '',
        'description': '',
        'value': '',
      },
    }),
    [ActionTypes.DELETE_SYSTEM_PARAMETERS_DATA]: (state) => ({
      ...state,
      'values': {
        ...state.values,
        'code': '',
        'description': '',
        'value': '',
      },
    }),
  })(state, action);
};
